"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { FormProvider } from "@/integrations/forms/FormProvider";
import { Mail, Phone, MapPin, Clock } from "lucide-react";
export default function Contact() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: formRef,
    isVisible: formVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: infoRef,
    isVisible: infoVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section className="bg-light-background py-24">
      <div className="container mx-auto px-6 max-w-7xl">
        <div ref={headerRef} className={`text-center mb-16 transition-all duration-[150ms] ease-[cubic-bezier(0.4,0,0.2,1)] ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          <h1 className="font-display text-5xl font-bold mb-4 !text-[hsl(22,78%,26%)] md:text-6xl">
            Get in Touch
          </h1>
          <div className="h-1 w-24 bg-primary mx-auto"></div>
          <p className="text-muted-foreground text-lg mt-6 max-w-2xl mx-auto">
            Contact Salem Ballama Auditing for expert financial guidance and
            compliance support in Dubai and across the UAE.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          <div ref={formRef} className={`transition-all duration-[150ms] ease-[cubic-bezier(0.4,0,0.2,1)] ${formVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
            <Card className="border border-border shadow-soft hover:shadow-medium transition-all duration-[150ms] bg-background">
              <CardHeader className="border-b border-border">
                <CardTitle className="font-semibold text-2xl font-display !text-[hsl(22,78%,26%)]">
                  Send Us a Message
                </CardTitle>
              </CardHeader>
              <CardContent className="pt-6">
                <FormProvider>
                  <form className="space-y-6">
                    <div>
                      <label htmlFor="name" className="block text-sm font-semibold mb-2 !text-[hsl(22,78%,26%)]">
                        Full Name
                      </label>
                      <input type="text" id="name" name="name" className="w-full px-4 py-3 border border-border rounded-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring transition-all duration-[120ms] bg-background text-foreground-light" placeholder="Your Name" />
                    </div>

                    <div>
                      <label htmlFor="email" className="block text-sm font-semibold mb-2 !text-[hsl(22,78%,26%)]">
                        Email Address
                      </label>
                      <input type="email" id="email" name="email" className="w-full px-4 py-3 border border-border rounded-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring transition-all duration-[120ms] bg-background text-foreground-light" placeholder="your.email@example.com" />
                    </div>

                    <div>
                      <label htmlFor="phone" className="block text-sm font-semibold mb-2 !text-[hsl(22,78%,26%)]">
                        Phone Number
                      </label>
                      <input type="tel" id="phone" name="phone" className="w-full px-4 py-3 border border-border rounded-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring transition-all duration-[120ms] bg-background text-foreground-light" placeholder="+971 4 123 4567" />
                    </div>

                    <div>
                      <label htmlFor="subject" className="block text-sm font-semibold mb-2 !text-[hsl(22,78%,26%)]">
                        Subject
                      </label>
                      <input type="text" id="subject" name="subject" className="w-full px-4 py-3 border border-border rounded-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring transition-all duration-[120ms] bg-background text-foreground-light" placeholder="Inquiry Regarding..." />
                    </div>

                    <div>
                      <label htmlFor="message" className="block text-sm font-semibold mb-2 !text-[hsl(22,78%,26%)]">
                        Message
                      </label>
                      <textarea id="message" name="message" rows={5} className="w-full px-4 py-3 border border-border rounded-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring transition-all duration-[120ms] resize-none bg-background text-foreground-light" placeholder="Tell us about your needs..."></textarea>
                    </div>

                    <button type="submit" className="w-full inline-flex items-center justify-center rounded-md text-foreground-primary px-6 py-3 font-semibold focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring transition-all duration-[150ms] ease-[cubic-bezier(0.34,1.56,0.64,1)] !bg-[hsl(22,78%,26%)] hover:bg-primary-hover hover:shadow-medium hover:-translate-y-0.5 active:bg-primary-dark active:translate-y-0">
                      Submit Inquiry
                    </button>
                  </form>
                </FormProvider>
              </CardContent>
            </Card>
          </div>

          <div ref={infoRef} className={`space-y-6 transition-all duration-[150ms] ease-[cubic-bezier(0.4,0,0.2,1)] ${infoVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
            <Card className="border border-border shadow-soft hover:shadow-medium transition-all duration-[150ms] bg-background">
              <CardContent className="pt-6">
                <div className="flex items-start space-x-4">
                  <div className="flex-shrink-0 w-12 h-12 rounded-md bg-primary/10 flex items-center justify-center">
                    <Phone className="w-6 h-6 text-primary-dark" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-lg mb-1 !text-[hsl(22,78%,26%)]">
                      Phone
                    </h3>
                    <p className="text-muted-foreground">+97144411000</p>
                  </div>
                </div>
              </CardContent>
            </Card>

            <Card className="border border-border shadow-soft hover:shadow-medium transition-all duration-[150ms] bg-background">
              <CardContent className="pt-6">
                <div className="flex items-start space-x-4">
                  <div className="flex-shrink-0 w-12 h-12 rounded-md bg-primary/10 flex items-center justify-center">
                    <Mail className="w-6 h-6 text-primary-dark" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-lg mb-1 !text-[hsl(22,78%,26%)]">
                      Email
                    </h3>
                    <p className="text-muted-foreground">
                      court@salemballama.com
                    </p>
                  </div>
                </div>
              </CardContent>
            </Card>

            <Card className="border border-border shadow-soft hover:shadow-medium transition-all duration-[150ms] bg-background">
              <CardContent className="pt-6">
                <div className="flex items-start space-x-4">
                  <div className="flex-shrink-0 w-12 h-12 rounded-md bg-primary/10 flex items-center justify-center">
                    <MapPin className="w-6 h-6 text-primary-dark" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-lg mb-1 !text-[hsl(22,78%,26%)]">
                      Office Location
                    </h3>
                    <p className="text-muted-foreground">
                      Office 5, Floor 12, Citibank Tower, Oud Metha, Dubai, United Arab Emirates
                    </p>
                  </div>
                </div>
              </CardContent>
            </Card>

            <Card className="border border-border shadow-soft hover:shadow-medium transition-all duration-[150ms] bg-background">
              <CardContent className="pt-6">
                <div className="flex items-start space-x-4">
                  <div className="flex-shrink-0 w-12 h-12 rounded-md bg-primary/10 flex items-center justify-center">
                    <Clock className="w-6 h-6 text-primary-dark" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-lg mb-1 !text-[hsl(22,78%,26%)]">
                      Business Hours
                    </h3>
                    <div className="text-muted-foreground">
                      <p>Monday to Thursday: 8:00 AM – 4:00 PM</p>
                      <p>Friday: 8:00 AM – 11:30 AM</p>
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </section>;
}